module.exports = __webpack_public_path__ + "static/media/csa_logo.e6cea06b.png";